/**
 * The PDP, analytics, and Product JSON-LD must select the same active price.
 * A blank (including whitespace-only) special is not a sale price.
 */
export function normalizeProductSpecial(special: unknown): string | null {
  const normalized = String(special ?? "").trim();
  return normalized || null;
}

export function resolveProductPrice(special: unknown, price: unknown): unknown {
  return normalizeProductSpecial(special) ?? price;
}

export function hasProductSpecial(special: unknown, price?: unknown): boolean {
  const normalized = normalizeProductSpecial(special);
  return Boolean(normalized && normalized !== String(price ?? "").trim());
}
